module.exports = __webpack_public_path__ + "static/media/prescription-bottle.8daf63d3.svg";